<div class="hide-acc">
  <div class="container-box">
    <!-- <app-breadcrumb [breadCrumbs]="breadCrumbs"></app-breadcrumb>-->
    <div class="row">
      <div class="col-sm-12 col-md-6 col-md-offset-3 break-text">
        <!-- <h1>{{formInputData && formInputData.userInfo && formInputData.userInfo.displayName}} </h1>-->
        <h1 class="inner-head">{{ formInputData && formInputData.userInfo && formInputData.userInfo.firstName}} {{ formInputData && formInputData.userInfo
          && formInputData.userInfo.lastName}} </h1>
        <!-- Error Block -->
        <div class="error-container" aria-live="assertive">
          <div class="alert valign-children-middle" *ngIf='setError'>
            <div class="alert-error" aria-label="Alert.">
              <i class="icon-badgealert" aria-hidden="true"></i>
            </div>
            <div>
              <h2>Something isn't working</h2>
              {{ErrorMessage}}
            </div>
          </div>
        </div>
        <div *ngIf="reviewComponentSuccessMessageFlag">
          <div class="alert valign-children-middle">
            <div class="alert-success" aria-label="Information.">
              <i class="icon-approval" aria-hidden="true"></i>
            </div>
            <div>
              <h2>Success</h2>
              <h2>{{reviewComponentSuccessMessage}}</h2>
            </div>
          </div>
        </div>
        <!-- Error Block End -->
        <div class='usr-info'>
          <p *ngIf='!errorFlag'> <a href='' *hasPermission='editUserPermission' class='mar-right' href='javascript:void(0)' (click)='editUser()'>Edit user details</a><span *hasPermission='removeUserPermission'> | </span>
            <a href='javascript:void(0)' aria-label="Remove user - opens a dialog box" *hasPermission='removeUserPermission' #removeUser class='mar-left' (click)='triggerRmUserPopup($event,focusable)'>Remove user</a>
          </p>
          <p class="break-all">
            <label class="data-label">Email</label> <br>
            {{formInputData && formInputData.userInfo && formInputData.userInfo.email}}
          </p>
          <p>
            <label class="data-label">Contact number</label> <br> {{formInputData && formInputData.userInfo && formInputData.userInfo.contactNumber}}
          </p>
        </div>

        <div *ngIf='showProduct'>
          <h2 class='padding-margin-bottom'>Product licenses assigned to this user</h2>
        </div>
        <div *ngIf='!showProduct'>
          <h2 class='padding-margin-bottom'>No product licenses are assigned to this user.</h2>
        </div>
        <div class='border-btm-solid'></div>
        <div *ngIf='showProduct'>
          <div class='row item-list' *ngFor="let prod of formInputData && formInputData.userSummaryProductModelArr; let i = index">
            <div [ngClass]="{'prod-disable': prod.fanTypeFlag}">
              <div class='col-sm-12 col-md-6 item-info'>
                <h2 class='padding-margin-bottom'>{{prod.productName}}</h2>
                <div>
                  <label class="data-label">Foundation account: </label><span>{{prod.fan}}</span><br>
                  <label class="data-label">Wireless number: </label><span>{{prod.billingCtn}}</span>
                  <p>{{prod.productDescription}}</p>

                </div>
                <ng-template let-item ngFor [ngForOf]="prod.extProperties.items" let-i="index">
                  <div class='user-product-info'>
                    <label class="data-label">Required information</label><br>
                    <label class="data-label">{{item.name}}: </label><span>{{item.value}}</span>
                  </div>
                </ng-template>
                <!--<div class='user-product-info'>
              <label>Required information</label><br>
              <label>Device ID: </label><span>13908asdf</span>
            </div>-->
              </div>
            </div>
            <div class='col-sm-12 col-md-6 prod-unassign' *ngIf='!errorFlag'>
              <div *ngIf='!prod.fanTypeFlag'>
                <a href='javascript:void(0)' class='right' (click)="openPopUp(focusable, i)" aria-label="Un-assign license - opens a dialog box" *hasPermission='assignunassignPermission'>Un-assign license</a>
              </div>
              <div *ngIf='prod.fanTypeFlag'>
                <p class="info-icon"><i class="icon-flat-info"></i>This account is managed by different administrators.</p>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
        </div>
        <div class='line-footer text-right' *hasPermission='assignunassignPermission'>
          <button class='btn btn-secondary col-sm-12' (click)='assign_product()' *ngIf='!errorFlag'>Assign licenses</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- unAssing popup close here -->
<app-modal [showModal]="unAssignPopup" [modalClass]="modalClass">
  {{UloadFocustelements()}}
  <div #unAssign (keydown)="UhandleKeydown($event)">
    <div class="modal-header">
      <h2 id='modalHeaderUnassign' tabindex="0">Un-assign a user</h2>
    </div>
    <div class="corner-button">
      <button type="button" #focusable class="close" aria-label="Close" (click)="cancel($event)">x</button>
    </div>
    <div class="modal-body break-text">
      <div class="unassign-user"><strong>Selected user</strong>
        <div>{{ formInputData && formInputData.userInfo && formInputData.userInfo.firstName }} {{ formInputData && formInputData.userInfo
          && formInputData.userInfo.lastName }}</div>
        <p>{{ formInputData && formInputData.userInfo && formInputData.userInfo.email }}</p>
      </div>
      <div><strong>Un-assign this user's license for:</strong>
        <div>{{ singleUserDetail && singleUserDetail.specName }} </div>
        <div><strong>Foundation account:</strong> {{fan}}</div>
        <div><strong>Wireless number:</strong> {{ctn}}</div>
      </div>
    </div>
    <div class="col-sm-12 modal-footer">
      <hr/>
      <button (click)="updateUnAssignDetails($event)" class="btn btn-secondary logInTest pull-right">Un-assign</button>
      <a class="btn btn-link btn-cart pull-right" href="javascript:void(0)" (click)="cancel($event)">Cancel</a>
    </div>
  </div>
</app-modal>
<!-- RemoveUser popup close here -->
<app-modal [showModal]="ruPopup" [modalClass]="modalClass">
  {{loadFocustelements()}}
  <div #remove (keydown)="handleKeydown($event)">
    <div class="modal-header">
      <h2 id='modalHeader' tabindex="0"> Confirm removal of user </h2>
    </div>
    <div class="corner-button">
      <button type="button" #focusable class="close" aria-label="Close" (click)="removeUser(false)">x</button>
    </div>
    <div class="modal-body">
      <strong> {{formInputData && formInputData.userInfo && formInputData.userInfo.firstName}} {{formInputData && formInputData.userInfo && formInputData.userInfo.lastName}} will be: </strong>
      <div class='bullet-list'>
        <ul>
          <li *ngIf='showProduct'>Un-assigned from licenses for the following products</li>
          <li>Removed from the system</li>
        </ul>
      </div>
      <div *ngIf='showProduct'>
        <div class='prod-catalog' *ngFor="let prod of formInputData && formInputData.userSummaryProductModelArr; let i = index">

          <h4> {{prod.productName}} </h4>
          <div>
            <div> <strong> Foundation account: </strong> {{ prod.fan }}</div>
            <div> <strong> Wireless number: </strong> {{ prod.billingCtn }}</div>
            <div> {{ prod.productDescription }} </div>
          </div>

        </div>
      </div>
    </div>
    <div class="text-right modal-footer">
      <hr />
      <div class="button-group">
        <button class="btn btn-secondary pull-right" (click)="removeUser(true)" [checkImpersonator]='csrPermissionRemoveButton' aria-label="Remove.">Remove</button>
        <a href="javascript:void(0)" class="btn btn-link" (click)="removeUser(false)">Cancel</a>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
</app-modal>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>